import contentFiltersApi from '@/api/contentFilters.js'

export const resetState = ({ commit }) => {
  commit('resetState')
}

export const load = ({ commit }) => {
  return contentFiltersApi.getCategories().then(categories => {
    commit('setCategories', categories)

    return categories
  })
}

export const loadCustom = ({ commit }, group_id) => {
  return contentFiltersApi.getAllCustomFilters(group_id).then(categories => {
    commit('setCustomCategories', categories)

    return categories
  })
}

export const addCustomCategory = ({ commit }, categories) => {
  commit('addCustomCategory', categories)
}

export const updateCustomCategory = ({ commit }, categories) => {
  commit('updateCustomCategory', categories)
}

export const removeCustomCategory = ({ commit }, category_id) => {
  commit('removeCustomCategory', category_id)
}